import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProfileSectionCountProps {
  count: number;
}

/** Count pill shown beside collapsible section titles on the member profile screen. */
const ProfileSectionCount: React.FC<ProfileSectionCountProps> = ({ count }) => {
  const { t } = useTranslation('common');

  return (
    <span className="profile-section__count" aria-label={t('itemsCount', { count })}>
      {count}
    </span>
  );
};

export default ProfileSectionCount;
